import patternReducer from './pattern'

let reducers = {
  pattern: patternReducer,
}

export default reducers